import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button, Row } from "reactstrap";
import moment from "moment";

//Context
import { useAuth } from "../../../context/auth";

// Components
import MainCard from "../../../components/MainCard/MainCard";
import TabelaListagemFichas from "../../../components/TabelaListagemFichas/TabelaListagemFichas";
import mascaras from "../../../helpers/mascaras";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";

export default function RelatorioGeradoresSemContratoFirmado({
  dadosRelatorio,
  btnVoltar,
  filtros,
}) {
  const { setupVariavel, session } = useAuth();
  const refRelatorio = useRef();
  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersGeradoresSemContratoFirmado = [
    { value: "Fantasia", objectValue: "fantasia", align: "left" },
    { value: "Razão Social", objectValue: "razaoSocial", align: "left" },
    { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
    {
      value: "Endereço",
      objectValue: "endereco",
      align: "left",
      options: { display: false },
    },
    { value: "Status", objectValue: "status", align: "left" },
    { value: "Categoria", objectValue: "categoria", align: "left" },
    {
      value: "Ramo de atividade",
      objectValue: "ramoDeAtividade",
      align: "left",
    },
    { value: "Contratos", objectValue: "contratos", align: "left" },
    { value: "Característica", objectValue: "caracteristica", align: "left" },
    { value: "Data do Cadastro", objectValue: "dataCadastro", align: "left" },
  ];

  //headers da exportação do csv
  const headersExport = [
    { key: "fantasia", label: "FANTASIA" },
    { key: "razaoSocial", label: "RAZÃO SOCIAL" },
    { key: "cpfcnpj", label: "CPF/CNPJ" },
    { key: "endereco", label: "ENDEREÇO" },
    { key: "status", label: "STATUS" },
    { key: "categoria", label: "CATEGORIA" },
    { key: "ramoDeAtividade", label: "RAMO DE ATIVIDADE" },
    { key: "contratos", label: "CONTRATOS" },
    { key: "caracteristica", label: "CARACTERISTICA" },
    { key: "dataCadastro", label: "DATA DO CADASTRO" },
]

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: "Relatório geradores sem contrato firmado",
  });

    //Botão de exportação csv
    const BtnExportCsv = () => {
      return (
          <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
              <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
          </Button>
      )
  }

  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
    <CSVLink 
      separator={";"} 
      data={dadosRelatorio?.map((value) => {
        value.cpfcnpj = !!value.cpfcnpj
          ? mascaras.cpfcnpjMask(value.cpfcnpj)
          : value.cpfcnpj;
        return value;
      }) || []} 
      headers={headersExport} 
      filename="Relatorio de geradores sem contrato firmado.csv" 
      target="_blank"
      ref={exportRef}
    >
     </CSVLink>
      
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>
        {setupVariavel?.logoTipo && (
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={"data:image/png;base64," + setupVariavel?.logoTipo}
              width={250}
            />
          </div>
        )}
        <div className="header">
          <h4 className="text-black">
            Relatório de geradores sem contrato firmado
          </h4>
        </div>
        <div className="body">
          <h5 className="mt-4 rounded-3 bg-secondary text-light p-2">
            Lista de geradores
          </h5>
          <Row>
            <TabelaListagemFichas
              headers={headersGeradoresSemContratoFirmado}
              items={
                dadosRelatorio?.map((value) => {
                  value.cpfcnpj = !!value.cpfcnpj
                    ? mascaras.cpfcnpjMask(value.cpfcnpj)
                    : value.cpfcnpj;
                  return value;
                }) || []
              }
              scrollbar={false}
            />
          </Row>
        </div>
      </div>
    </MainCard>
  );
}
